import React from 'react';
import { Play, Clock } from 'lucide-react';
import { FormVideo } from '../../data/forms';
interface VideoCardProps {
  video: FormVideo;
}
export function VideoCard({
  video
}: VideoCardProps) {
  return <div className="bg-white rounded-xl border border-slate-200 shadow-sm hover:shadow-md transition-shadow overflow-hidden group" data-id="element-196">
      {/* Video Thumbnail */}
      <div className="relative aspect-video bg-slate-900 overflow-hidden" data-id="element-197">
        <img src={video.thumbnail} alt={video.title} className="w-full h-full object-cover opacity-70 group-hover:opacity-60 transition-opacity" data-id="element-198" />

        {/* Play Button Overlay */}
        <div className="absolute inset-0 flex items-center justify-center" data-id="element-199">
          <div className="w-16 h-16 rounded-full bg-white/90 flex items-center justify-center group-hover:bg-white transition-colors" data-id="element-200">
            <Play className="h-7 w-7 text-[#dc2626] ml-1" fill="currentColor" data-id="element-201" />
          </div>
        </div>

        {/* Duration Badge */}
        <div className="absolute bottom-3 right-3 bg-black/80 text-white text-xs font-medium px-2 py-1 rounded flex items-center" data-id="element-202">
          <Clock className="h-3 w-3 mr-1" data-id="element-203" />
          {video.duration}
        </div>
      </div>

      {/* Video Info */}
      <div className="p-4" data-id="element-204">
        <p className="text-xs text-slate-500 mb-1" data-id="element-205">{video.instructor}</p>
        <h3 className="text-base font-bold text-[#1a2332] mb-2 line-clamp-2" data-id="element-206">
          {video.title}
        </h3>
        <p className="text-sm text-slate-600 line-clamp-2" data-id="element-207">
          {video.description}
        </p>
      </div>
    </div>;
}